import { errorMessagesSection, faExclamationCircle, FormStyle, infoPlaceholderSection, React, SelectStyle } from "@/imports-files/components/custom-select";
import { Editor } from '@tinymce/tinymce-react';

export function CustomEditor(props)
{

return(
       
       <div className= {props.style ? `text_editor_error_container ${props.identifierClass||''}` :`text_editor_container ${props.identifierClass||''}`}>
        <Editor
            apiKey          =   {process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
            onInit          =   {props.onInit}
            textareaName    =   {props.textareaName}
            id              =   {props.id}
            value           =   {props.value}
            onEditorChange  =   {props.onEditorChange}
            init            =   {props.init}
            disabled        =   {props.disabled}
            key             =   {props.key}
          />


           {
             props.style != undefined ?  errorMessagesSection(  props.textareaName, FormStyle, props.formik)
                                      :  infoPlaceholderSection( props.infoPlaceholder, FormStyle)
           }

       </div>
     )
}



